export const UPDATE_COMPANY_SERVICES_DATA = 'UPDATE_COMPANY_SERVICES_DATA'